import { render } from "./ImprintPage.vue?vue&type=template&id=735f4270&scoped=true"
import script from "./ImprintPage.vue?vue&type=script&lang=js"
export * from "./ImprintPage.vue?vue&type=script&lang=js"

import "./ImprintPage.vue?vue&type=style&index=0&id=735f4270&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735f4270"]])

export default __exports__